import { useEffect } from 'react';

import { useScrollToView } from '@Hooks/useScrollToView';
import LayoutMain from '@Layouts/LayoutMain';
import Page from '@Components/Page';
import PageTopBar from '@Components/PageTopBar';
import usePage from '@Queries/usePage';
import MainBanner from './elems/MainBanner';
import Description from './elems/Description';
import Decision from './elems/Decision';
import Categories from './elems/Categories';
import Benefits from './elems/Benefits';
import FooterBanner from './elems/FooterBanner';
import styles from './PageDofamin.module.css';

import type { PageData } from './typings';
import type { FC } from 'react';

const pageName = 'Лендинг Дофамин';

const PageDofamin: FC = () => {
  const { data: page } = usePage<PageData>();
  const { handleScrollTo } = useScrollToView();
  useEffect(() => {
    if (!page) return;

    const hash = window.location.hash;

    if (!hash) return;

    const elem = document.getElementById(hash.slice(1));

    if (!elem) return;

    handleScrollTo(elem);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  return (
    <LayoutMain>
      <Page>
        <PageTopBar breadcrumbs={page.breadcrumbs} />
        <div className={styles.page}>
          <MainBanner className={styles.mainBanner} />
          <Description className={styles.description} />
          <Decision className={styles.decision} />
          <Categories
            className={styles.categories}
            categories={page.categories}
            analyticsTitle={pageName}
          />
          <FooterBanner />
          <Benefits className={styles.benefits} />
        </div>
      </Page>
    </LayoutMain>
  );
};

export default PageDofamin;
